module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"assignedTo":"Assigned to"},"fr":{"assignedTo":"Assigné à"},"de":{"assignedTo":"Zugewiesen an"}}')
  delete Component.options._Ctor
}
